import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';
import { carouselInfoType } from '@/components/Carousel/types';
import CarouselProvider from '@/components/Carousel/CarouselProvider';
import SlickCarousel from '@/components/Carousel/SlickCarousel';

function productCarouselImage(src: string) {
  return [
    {
      src,
      size: { width: 221, aspectRatio: 1 / 1 },
      breakpoint: 320,
    },
    {
      src,
      size: { width: 443, aspectRatio: 1 / 1 },
      breakpoint: 767,
    },
    {
      src,
      size: { width: 200, aspectRatio: 1 / 1 },
      breakpoint: 768,
    },
    {
      src,
      size: { width: 272, aspectRatio: 1 / 1 },
      breakpoint: 1023,
    },
    {
      src,
      size: { width: 153, aspectRatio: 1 / 1 },
      breakpoint: 1024,
    },
    {
      src,
      size: { width: 243, aspectRatio: 1 / 1 },
      breakpoint: 1440,
    },
  ];
}

export default function ProductCarousel({
  textPosition,
  eyeBrowText,
  OptionalHeader,
  headerTag,
  optionalSubHeader,
  cta,
  isMobileSlider,
  isSetMaxWidth,
  items,
  anchorLinkID,
  margin,
  centerText,
  slidesToShow = '6',
}) {
  const { formattedItems, hoverImages } = items
    ? items.reduce(
        (acc, item) => {
          acc.formattedItems.push({
            name: item.name,
            description: item.description,
            link: item.link ? item.link : null,
            imgSrcs: productCarouselImage(item.imgSrcs),
            altText: item.altText,
          });

          acc.hoverImages.push({
            hoverImage:
              item.hoverImage !== undefined && item.hoverImage !== null ? productCarouselImage(item.hoverImage) : null,
            hoverImageAlt: item.HoverImageAltText || null,
          });

          return acc;
        },
        { formattedItems: [], hoverImages: [] }
      )
    : { formattedItems: [], hoverImages: [] };

  const carouselInfo = {
    name: 'product-carousel',
    type: carouselInfoType.product,
  };
  const isShowCarousel = formattedItems.length > Number(slidesToShow);
  const isCenterText = textPosition === 'center';

  return (
    <div className="product-carousel" {...getAnchorId(anchorLinkID)}>
      <CarouselProvider centerText={centerText} hoverImages={hoverImages}>
        <SlickCarousel
          eyeBrowText={eyeBrowText}
          optionalHeader={OptionalHeader}
          headerTag={headerTag}
          optionalSubHeader={optionalSubHeader}
          isCenterText={isCenterText}
          isShowCarousel={isShowCarousel}
          isMobileSlider={isMobileSlider}
          isProduct
          isSetMaxWidth={isSetMaxWidth}
          items={formattedItems}
          cta={cta}
          className={getComponentMargin(margin)}
          carouselInfo={carouselInfo}
          headerClassName="desktop:tw-ml-0"
          slidesToShow={Number(slidesToShow)}
          subHeaderClassName={`tw-mb-4 md:tw-mx-0 ${isCenterText ? 'tw-text-center' : 'tw-text-left'} large:tw-mb-8`}
        />
      </CarouselProvider>
    </div>
  );
}
